import React from 'react';

function joinClassNames(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

export default function PanelSection({
  as = 'section',
  title,
  eyebrow,
  actions,
  className = '',
  headerClassName = '',
  contentClassName = '',
  children,
  ...rest
}) {
  const SectionTag = as;

  return (
    <SectionTag className={joinClassNames('panel-section', className)} {...rest}>
      {(title || eyebrow || actions) && (
        <div className={joinClassNames('panel-section-head', headerClassName)}>
          <div className="panel-section-head-copy">
            {eyebrow && <span className="panel-section-eyebrow">{eyebrow}</span>}
            {title && <h2 className="panel-section-title">{title}</h2>}
          </div>
          {actions && <div className="panel-section-actions">{actions}</div>}
        </div>
      )}

      <div className={joinClassNames('panel-section-content', contentClassName)}>
        {children}
      </div>
    </SectionTag>
  );
}